module.exports = __webpack_public_path__ + "img/党徽btn.3bfb6bb8.png";